import { render, staticRenderFns } from "./SliderImages.vue?vue&type=template&id=76f145be&scoped=true&"
import script from "./SliderImages.vue?vue&type=script&lang=js&"
export * from "./SliderImages.vue?vue&type=script&lang=js&"
import style0 from "./SliderImages.vue?vue&type=style&index=0&id=76f145be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f145be",
  null
  
)

component.options.__file = "SliderImages.vue"
export default component.exports